export const OPSGENIE_LEGACY_COPILOT_TYPE = "OpsGenieV2";
export const OPSGENIE_V5_COPILOT_TYPE = "OpsGenieV5";
